import Vue from 'vue'
import api from '@/api'

export const defaultSiteConfig = {
  brandTitle: 'DayZ 生存狂服务器',
  brandShopTitle: 'DayZ 生存狂赞助商城',
  pointsName: '积分',
  diamondsName: '钻石',
  walletInheritSql: 'balance = balance + ROUND(topup * {ratio}), topup = 0',
  icpLicense: '',
  publicSecurityRecord: ''
}

export const siteConfigState = Vue.observable({
  ...defaultSiteConfig,
  loaded: false
})

export async function ensureSiteConfig () {
  if (siteConfigState.loaded) return siteConfigState
  try {
    const res = await api.getSiteConfig()
    const data = res && res.data ? res.data : res
    Object.assign(siteConfigState, defaultSiteConfig, data || {}, { loaded: true })
  } catch (e) {
    Object.assign(siteConfigState, defaultSiteConfig, { loaded: true })
  }
  return siteConfigState
}

export function currencyName (currency = 'points') {
  return currency === 'diamonds' ? siteConfigState.diamondsName : siteConfigState.pointsName
}
